export default "/images/vendor/flag-icon-css/flags/1x1/gb-wls.svg?910c0fb3440a800691cbbe0b6ebe3e91";